/**
 * 精简版本对话框
 */
import { ChatConversationProvider } from 'views/Conversation/Chat/contexts/ChatConversationContext';
import { ChatSection } from 'views/Conversation/components/ChatSection';
import { LightChatHeader } from './LightChatHeader';
import { LightChatSide } from './LightChatSide';
import { useSideRightDisplay } from 'hooks/business/conversationsHooks/useConversationSide';
import { ReceptionStatisticsHeader } from 'views/Conversation/ReceptionStatisticsHeader';

interface LightConversationProps {
  conversation: Conversation.Conversation;
}

export const LightConversation = (props: LightConversationProps) => {
  const { conversation } = props;
  const { conversationId } = conversation;

  const sideRightDisplay = useSideRightDisplay();

  return (
    <div className="w-full h-full flex items-start border-0 border-t border-solid border-[#f0f2f5] overflow-hidden">
      <ChatConversationProvider conversationId={conversationId}>
        <div className="flex flex-col h-full flex-1 overflow-hidden">
          <ReceptionStatisticsHeader />
          <LightChatHeader
            className="flex-shrink-0 flex-grow-0 basis-[48px] border-0 border-b border-solid border-[#E1E4EB]"
            conversation={conversation}
          />
          <ChatSection conversation={conversation} />
        </div>
        {sideRightDisplay && (
          <LightChatSide
            className="basis-[420px] h-full flex-shrink-0 flex-grow-0 border-0 border-l border-solid border-[#E1E4EB]"
            conversation={conversation}
          />
        )}
      </ChatConversationProvider>
    </div>
  );
};
